import { IntegrationServices } from '@sequencehq/api'
import { atom } from 'jotai'
import { integrationName } from 'lib/integrations/integrationName'

export type CustomerImportStep = 'integration' | 'customers'
export const currentStepAtom = atom<CustomerImportStep>('integration')

export const selectedIntegrationAtom = atom<IntegrationServices | null>(null)

export const integrationStepSkippedAtom = atom(false)

export const selectedCustomerIdsAtom = atom<string[]>([])

export const selectedIntegrationNameAtom = atom<string | null>(get => {
  const selectedIntegration = get(selectedIntegrationAtom)
  return selectedIntegration ? integrationName(selectedIntegration) : null
})
